module.exports = __webpack_public_path__ + "img/icon-wifi-3.23e34b40.svg";